import { Box, Button } from "@mui/material"
import type { PeriodType } from "@crm-src/types/financial-metrics"

interface TimeRangeSelectorProps {
  selected: PeriodType
  onChange: (period: PeriodType) => void
}

export function TimeRangeSelector({ selected, onChange }: TimeRangeSelectorProps) {
  const periods: { value: PeriodType; label: string }[] = [
    { value: '1M', label: 'Month' },
    { value: '6M', label: 'Half Year' },
    { value: '1Y', label: 'Year' }
  ]

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {periods.map((period) => (
        <Button
          key={period.value}
          variant={selected === period.value ? "contained" : "outlined"}
          color={selected === period.value ? "primary" : "inherit"}
          onClick={() => onChange(period.value)}
        >
          {period.label}
        </Button>
      ))}
    </Box>
  )
}
